// src/another-app/AnotherApp.js
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Stack, Paper, Typography } from "@mui/material";
import { Helmet } from "react-helmet";

const AnotherApp = () => {
  return (
    <>
      <Helmet>
        <title>Another App | Talk About Finance</title>
        <meta
          name="description"
          content="A placeholder space for experimenting with new personal finance tools."
        />
        <link rel="canonical" href="https://talkabout.finance/apps/another" />
      </Helmet>

      <Paper sx={{ p: 3, mt: 4, mb: 6, borderRadius: 2 }}>
        <Stack spacing={2}>
          <Typography variant="h5">Another App</Typography>
          <Typography>This is another app you can build!</Typography>
          <Button variant="outlined" component={RouterLink} to="/apps">
            Back to apps
          </Button>
        </Stack>
      </Paper>
      <Box sx={{ mt: 3, mb: 4 }}>
        <Typography variant="subtitle2" gutterBottom>
          About these calculations
        </Typography>
        <Typography variant="body2" color="text.secondary">
          These figures are illustrative and based on the assumptions shown. They may not reflect the terms of specific financial products or your individual circumstances. You should verify results independently and, where appropriate, seek advice from a qualified professional.
        </Typography>
      </Box>
    </>
  );
};

export default AnotherApp;
